import React from "react";

import Slide from "./slide";

export default ({ slides, sectionName }) => (
  <section
    className="js-fullheight"
    data-section={sectionName.replace(/[^a-zA-Z0-9]/, "-")}
    id="colorlib-hero"
  >
    <div className="flexslider js-fullheight">
      <ul className="slides">
        {slides.map(slide => <Slide {...slide} key={slide.heading} />)}
      </ul>
    </div>
  </section>
);



// WEBPACK FOOTER //
// ./src/components/slidesContainer.js